export const INFO = 'info'
export const PRESENTATION = 'presentation'
export const SORTING = 'sorting'
export const QUIZ = 'quiz'
export const ORDERING = 'order'
export const INVITE = 'invite'



// WEBPACK FOOTER //
// ./src/modules/Lessons/Constants/steps.js